import { msal, state } from "@/services/msal-config";
import { ref } from "vue";
import router from "@/router";

export function useAuth() {
    const isAuthenticated = ref(false)

    const login = async () => {
        if (!msal) {
            throw new Error('MSAL not initialized. Call initializeMsal() before using MSAL API.')
        }

        sessionStorage.setItem("redirectAfterLogin", router.currentRoute.value.fullPath)

        try {

            const loginResponse = await msal.loginRedirect()
            isAuthenticated.value = true

            console.log(`Login success: ${loginResponse !== undefined}`)
        } catch (e) {
            console.error(`Login error: ${e}`)
        }

        state.isAuthenticated = isAuthenticated.value
        return isAuthenticated.value
    }

    const logout = async () => {
        if (!msal) {
            throw new Error('MSAL not initialized. Call initializeMsal() before using MSAL API.')
        }

        await msal.logoutRedirect()
        isAuthenticated.value = false
        state.isAuthenticated = false
        console.log(`Logged out`)
    }

    const handleRedirect = async () => {
        try {
            const redirectResult = await msal.handleRedirectPromise();

            state.isAuthenticated = msal.getAllAccounts().length > 0
            state.user = msal.getAllAccounts()[0]
        } catch (error) {
            console.log(`Redirect error: ${error}`)
        }
    }

    return { isAuthenticated, login, logout, handleRedirect }
}
